export const SYNMIO_SCRIPT_ID = "synapz-invoke-script-000";
